export default "__VITE_ASSET__2ee672d6__"